// Auto-close ALL filter dropdowns after selection
document.addEventListener('change', function(e) {
  if (e.target.matches('.facets__item input[type="checkbox"], .facet-checkbox input[type="checkbox"]')) {
    var details = e.target.closest('details');
    if (details) {
      setTimeout(function() {
        details.removeAttribute('open');
      }, 300);
    }
  }
});

// Also close when clicking outside any open filter dropdown
document.addEventListener('click', function(e) {
  if (!e.target.closest('details.facets__disclosure')) {
    document.querySelectorAll('details.facets__disclosure[open]').forEach(function(details) {
      details.removeAttribute('open');
    });
  }
});
